export const PW_LABELS = ["Too short", "Weak", "Okay", "Good", "Strong"];

// 0–4 heuristic: length floor (8), then bonuses for length, mixed case, and a
// digit/symbol. Mirrors the server-side minimum (>= 8) used at registration.
export function pwScore(pw: string): number {
  if (pw.length < 8) return 0;
  let s = 1;
  if (pw.length >= 12) s++;
  if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) s++;
  if (/\d/.test(pw) || /[^A-Za-z0-9]/.test(pw)) s++;
  return Math.min(s, 4);
}

export function PasswordStrength({ password }: { password: string }) {
  if (!password) return null;
  const score = pwScore(password);
  return (
    <div className="pw-meter" aria-hidden="true">
      <div className="pw-meter-bars">
        {[0, 1, 2, 3].map((i) => (
          <span key={i} className={`pw-bar${i < score ? ` lvl-${score}` : ""}`} />
        ))}
      </div>
      <span className="pw-meter-label">{PW_LABELS[score]}</span>
    </div>
  );
}
